<template>
  <section class="business-get-started">
    <div class="business-get-started__container container section section--padding-l-extra">
      <div class="business-get-started__content">
        <h3 class="business-get-started__headline">
          {{ $t(`${i18nKey}.headline`) }}
        </h3>

        <buy-button v-if="i18nKey === 'teams'" :event-category="eventCategory" event-name="teams" />
        <button-component
          v-else
          class="business-get-started__cta cta"
          :use-router="true"
          href="plans"
          :event-category="eventCategory"
          event-name="plans"
        >
          {{ $t("cta") }}
        </button-component>
      </div>

      <div class="business-get-started__image">
        <img class="business-get-started__img" :src="$options.earphonesSvg" />
      </div>
    </div>
  </section>
</template>

<script>
import BuyButton from "./buy-button"
import buttonComponent from "@/shared/button"
import earphonesSvg from "@/pages/business/images/earphones.svg"

export default {
  name: "BusinessGetStarted",
  components: {
    BuyButton,
    buttonComponent
  },
  earphonesSvg,
  props: {
    i18nKey: { type: String, default: "landing" }
  },
  computed: {
    eventCategory() {
      return `body-20210217-business_get_started_${this.i18nKey}`
    }
  },
  i18n: {
    messages: {
      en: {
        landing: {
          headline: "Start building a culture of lifelong learning today"
        },
        teams: {
          headline: "Make Blinkist your newest employee benefit"
        },
        business: {
          headline: "Help your team build better learning habits today"
        },
        cta: "See plans"
      },
      de: {
        landing: {
          headline: "Bringen Sie jetzt mehr Wissen in den Alltag Ihres Teams"
        },
        teams: {
          headline: "So binden Sie Ihre Mitarbeiter langfristig an sich"
        },
        business: {
          headline: "Help your team build better learning habits today"
        },
        cta: "Preise ansehen"
      }
    }
  }
}
</script>

<style lang="scss">
.business-get-started {
  background-color: $midnight4;

  &__headline {
    @include font-style(h2, $color: $white);

    margin-bottom: $spacing-48;
  }

  &__container {
    @include grid-css;

    position: relative;

    text-align: center;
  }

  &__content {
    @include grid-css-element(12);

    @include media(min-width, m) {
      @include grid-css-element(10, 2);
    }

    @include media(min-width, l) {
      @include grid-css-element(8, 3);
    }
  }

  &__image {
    @include grid-css-element(12);
  }

  &__img {
    position: absolute;
    top: 0%;
    right: 2%;

    display: none;

    @include media(min-width, m) {
      display: block;
      width: 260px;
    }

    @include media(min-width, l) {
      width: auto;
    }
  }
}
</style>
